export default "__VITE_ASSET__bce784fd__"